import React from "react";

export const FishIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2031 3.875C14.0781 3.875 13.957 3.89453 13.8398 3.92969L11.3203 4.70312C8.56641 5.55078 6.6875 8.09766 6.6875 10.9766V12.6523C7.57422 12.8008 8.25 13.5742 8.25 14.5V20.125C8.25 21.1602 7.41016 22 6.375 22H5.125C4.08984 22 3.25 21.1602 3.25 20.125V14.5C3.25 13.5703 3.92578 12.8008 4.8125 12.6523V10.9766C4.8125 7.27344 7.22656 4 10.7695 2.91406L13.2852 2.13672C13.582 2.04688 13.8906 2 14.1992 2C15.918 2 17.3086 3.39453 17.3086 5.10938V7.3125C17.3086 7.83203 16.8906 8.25 16.3711 8.25C15.8516 8.25 15.4336 7.83203 15.4336 7.3125V5.10938C15.4375 4.42969 14.8828 3.875 14.2031 3.875ZM5.125 14.5V20.125H6.375V14.5H5.125ZM13.25 15.4375C13.25 12.6406 15.4219 10.4453 16.7266 9.65234C16.8945 9.55078 17.1016 9.55078 17.2734 9.65234C18.582 10.4453 20.75 12.6445 20.75 15.4375C20.75 16.6875 20.125 18.5625 18.25 19.8125L19.3164 20.8789C19.4336 20.9961 19.5 21.1562 19.5 21.3203V21.375C19.5 21.7188 19.2187 22 18.875 22H15.125C14.7812 22 14.5 21.7188 14.5 21.375V21.3203C14.5 21.1562 14.5664 20.9961 14.6836 20.8789L15.75 19.8125C13.875 18.5625 13.25 16.6875 13.25 15.4375ZM18.25 14.1875C18.25 13.668 17.832 13.25 17.3125 13.25C16.793 13.25 16.375 13.668 16.375 14.1875C16.375 14.707 16.793 15.125 17.3125 15.125C17.832 15.125 18.25 14.707 18.25 14.1875Z"
      fill="currentColor"
    />
  </svg>
);
